module.exports = __webpack_public_path__ + "494cd07c/img/search-filter-icon.c4751a52.svg";